export default "__VITE_ASSET__CaL4dj$z__"